import { render, staticRenderFns } from "./fleet-charging-panel.vue?vue&type=template&id=5bb58d54&scoped=true&"
import script from "./fleet-charging-panel.vue?vue&type=script&lang=js&"
export * from "./fleet-charging-panel.vue?vue&type=script&lang=js&"
import style0 from "./fleet-charging-panel.vue?vue&type=style&index=0&id=5bb58d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb58d54",
  null
  
)

export default component.exports